<ng-container *ngIf="tooltips && tooltips[activeTooltipIndex] as activeTooltip">
  <div
    #overlay
    class="overlay"
    [ngClass]="tooltipType"
    (click)="onOverlayClicked($event)"
  ></div>

  <div #tooltip class="tooltip">
    <i2g-tooltip
      [tooltip]="activeTooltip"
      [type]="tooltipType"
      [closeIcon]="closeIcon"
      [showNext]="showNext"
      [isLastInSequence]="isLastTooltip()"
      [progressText]="
        !showProgress
          ? undefined
          : ('ONBOARDING_TOOLTIP.X_OF_TOTAL'
            | translate
              : { current: activeTooltipIndex + 1, total: tooltips.length })
      "
      (clickTooltip)="loadNextTooltip()"
      (dismissTooltip)="dismiss()"
    >
    </i2g-tooltip>
  </div>
</ng-container>
